import {
    NotificationsByConsumer,
    notificationsByConsumerQuery,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createResourceQuery } from '@funtech-int/rival';
import { GraphQLError } from 'graphql';
import { useResources } from '@funtech-int/rival-react';

import { GraphqlClient } from '@/shared/lib/graphqlClient';

import { useGraphqlClient } from './useGraphqlClient';

export type NotificationsByConsumerQueryVariables = {
    consumer: string;
    platform: string;
    supportedTemplateIds: string[];
    supportedTemplateToActions: Record<string, string[]>;
    notificationCount: number;
};

interface NotificationsQueryContext {
    client: GraphqlClient;
    variables: NotificationsByConsumerQueryVariables;
}

interface NotificationsQueryResult {
    data: NotificationsByConsumer | null | undefined;
    errors?: GraphQLError[];
}

const notificationsQuery = createResourceQuery<
    NotificationsQueryContext,
    NotificationsQueryResult | null
>({
    key(ctx) {
        return [
            notificationsByConsumerQuery.name,
            ctx.variables.consumer,
            ...ctx.variables.supportedTemplateIds,
        ].join(':');
    },

    fetch(ctx) {
        return ctx.client.fetch({
            operation: notificationsByConsumerQuery,
            variables: ctx.variables,
        });
    },

    toJSON(response: any) {
        return { data: response.data, errors: response.errors };
    },

    hydrate(serialized: any) {
        const { data, errors } = serialized;
        return {
            data: notificationsByConsumerQuery.hydrate(data) as NotificationsByConsumer,
            errors,
        };
    },
});

export const useNotificationQuery = (variables: NotificationsByConsumerQueryVariables) => {
    const client = useGraphqlClient();
    const [result] = useResources(notificationsQuery({ client, variables }, { lifetime: 0 }));

    return {
        notification: result?.data?.firstNotification,
        errors: result?.errors ?? undefined,
    };
};
